"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invokeFactory = exports.unaryFactory = exports.GrpcWebError = void 0;
const grpc_web_1 = require("@improbable-eng/grpc-web");
const metrics_1 = require("./metrics");
const rxjs_1 = require("rxjs");
const urls_1 = require("./constants/urls");
const headers_1 = require("./constants/headers");
class GrpcWebError extends Error {
    constructor(response) {
        super(`[${response.status} ${grpc_web_1.grpc.Code[response.status]}] ${response.statusMessage}`);
        this.name = "GrpcWebError";
        this.code = response.status;
        this.metadata = response.trailers;
    }
    code;
    metadata;
}
exports.GrpcWebError = GrpcWebError;
const getCrossOriginTransport = (requestHost, requestEndpoint) => (options) => grpc_web_1.grpc.CrossBrowserHttpTransport({ withCredentials: true })({
    ...options,
    url: `${requestHost}/${requestEndpoint}`,
});
const setupGrpc = ({ hostURL, metricsPrefix, userAgent, ssoToken, endpointURL, serviceName, methodName, metadata, }) => {
    const start = performance.now();
    const requestHost = hostURL ?? urls_1.API_GW_HOST;
    const requestEndpoint = endpointURL ?? `${serviceName}/${methodName}`;
    metrics_1.grpcMetrics.logAttempt(metricsPrefix, methodName);
    // attach SSO token for authed grpc requests
    if (ssoToken) {
        metadata = metadata ?? new grpc_web_1.grpc.Metadata();
        metadata.set("Authorization", `Bearer ${ssoToken}`);
    }
    if (userAgent) {
        metadata = metadata ?? new grpc_web_1.grpc.Metadata();
        metadata.set(headers_1.USER_AGENT_HEADER_KEY, userAgent);
    }
    return { requestHost, requestEndpoint, requestMetadata: metadata, metricsKey: methodName, start };
};
/**
 * rpc.unary factory
 * sends authed grpc requests
 */
function unaryFactory(props) {
    return async function unary(methodDesc, _request, metadata) {
        return new Promise((resolve, reject) => {
            const { requestHost, requestEndpoint, requestMetadata, metricsKey, start } = setupGrpc({
                ...props,
                serviceName: methodDesc.service.serviceName,
                methodName: methodDesc.methodName,
                metadata,
            });
            const { metricsPrefix, onUnauthorizedError } = props;
            const unaryRpcOptions = {
                request: { ..._request, ...methodDesc.requestType },
                host: requestHost,
                metadata: requestMetadata,
                transport: getCrossOriginTransport(requestHost, requestEndpoint),
                debug: false,
                onEnd: (response) => {
                    metrics_1.grpcMetrics.logStatusCode(metricsPrefix, metricsKey, response.status);
                    if (response.status === grpc_web_1.grpc.Code.OK) {
                        metrics_1.grpcMetrics.logLatency(metricsPrefix, metricsKey, performance.now() - start);
                        resolve(response.message);
                    }
                    else {
                        if ([grpc_web_1.grpc.Code.Unauthenticated, grpc_web_1.grpc.Code.PermissionDenied].includes(response.status)) {
                            onUnauthorizedError();
                        }
                        else {
                            (0, metrics_1.logGeneralError)(metricsPrefix, metricsKey);
                        }
                        reject(new GrpcWebError(response));
                    }
                },
            };
            grpc_web_1.grpc.unary(methodDesc, unaryRpcOptions);
        });
    };
}
exports.unaryFactory = unaryFactory;
/**
 * rpc.invoke factory
 * returns streaming data with an Observable
 */
function invokeFactory(props) {
    return function invoke(methodDesc, _request, metadata) {
        const { requestHost, requestEndpoint, requestMetadata, metricsKey, start } = setupGrpc({
            ...props,
            serviceName: methodDesc.service.serviceName,
            methodName: methodDesc.methodName,
            metadata,
        });
        const { metricsPrefix, onUnauthorizedError } = props;
        return new rxjs_1.Observable((subscriber) => {
            const invokeRpcOptions = {
                request: { ..._request, ...methodDesc.requestType },
                host: requestHost,
                metadata: requestMetadata,
                transport: getCrossOriginTransport(requestHost, requestEndpoint),
                debug: false,
                onMessage: (message) => {
                    subscriber.next(message);
                },
                onEnd: (code, message) => {
                    metrics_1.grpcMetrics.logStatusCode(metricsPrefix, metricsKey, code);
                    if (code === grpc_web_1.grpc.Code.OK) {
                        metrics_1.grpcMetrics.logLatency(metricsPrefix, metricsKey, performance.now() - start);
                        subscriber.complete();
                    }
                    else {
                        if ([grpc_web_1.grpc.Code.Unauthenticated, grpc_web_1.grpc.Code.PermissionDenied].includes(code)) {
                            onUnauthorizedError();
                        }
                        else {
                            (0, metrics_1.logGeneralError)(metricsPrefix, metricsKey);
                            subscriber.error(message);
                        }
                    }
                },
            };
            grpc_web_1.grpc.invoke(methodDesc, invokeRpcOptions);
        });
    };
}
exports.invokeFactory = invokeFactory;
//# sourceMappingURL=improbableGrpcWebClient.js.map